module.exports = __webpack_public_path__ + "img/map-img.e8217084.png";